import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onUpload }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-24 h-24 rounded-full bg-muted flex items-center justify-center mb-6">
        <Icon name="FolderOpen" size={48} className="text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">No files found</h3>
      <p className="text-sm text-muted-foreground text-center max-w-md mb-6">
        This folder is empty. Upload files to get started with your S3 file management.
      </p>
      <Button iconName="Upload" iconPosition="left" onClick={onUpload}>
        Upload Files
      </Button>
    </div>
  );
};

export default EmptyState;